import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  return (
    <nav aria-label="面包屑导航" className="text-xs text-foreground-500 md:text-sm">
      <ol className="flex flex-wrap items-center gap-1.5">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-1.5">
              {item.to && !isLast ? (
                <Link to={item.to} className="transition-colors hover:text-primary-600">
                  {item.label}
                </Link>
              ) : (
                <span className="font-medium text-foreground-800" aria-current="page">
                  {item.label}
                </span>
              )}
              {!isLast && (
                <i className="ri-arrow-right-s-line text-sm leading-none text-foreground-300" aria-hidden="true"></i>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}